import * as Sentry from '@sentry/react';

type ExtraFieldDef = {
  key: string;
  extra?: Error | Record<string, string> | string;
}[];
type Severity = 'Error' | 'Info' | 'Warning' | null;

export const capture = (
  error: Error | string,
  arrayExtraField: ExtraFieldDef = null,
  severity: Severity = 'Error',
  addTags: {
    [key: string]: string;
  } = null
) => {
  console.error('CAPTURE LOG ENVIRO DEV : ', error);
  if (!process.env.REACT_APP_ENABLE_SENTRY) return;

  Sentry.withScope(function(scope) {
    if (arrayExtraField) {
      scope.setLevel(Sentry.Severity[severity]);
      arrayExtraField.forEach((conf, i) => {
        if (conf.key || conf.extra) return scope.setExtra(conf.key, conf.extra);
        return scope.setExtra('Details' + i, conf);
      });
    }
    if (addTags) {
      scope.setTags(addTags);
    }
    return Sentry.captureException(error);
  });
};
